import React from 'react';
import NumberUtils from '../../../utils/NumberUtils';

export const CreditCardStatementDate = ({ account }) => (
  <div className="account-summary__more__balances cardsticky__hide">
    <div className="account-summary__more__balances__details">
      <dl>
        <dt>Last statement date</dt>
        <dd>{account.accountDetails.lastStatementDate}</dd>
      </dl>
      <dl>
        <dt>Last statement balance</dt>
        <dd>
          {NumberUtils.appendCurrency(
            '{}',
            account.accountDetails.lastStatementBalance
          )}
        </dd>
      </dl>
    </div>
  </div>
);
